import React from 'react';
import { Section } from './ui/Section';
import { BookOpen, Clock, Activity, Calendar, Shield } from 'lucide-react';
export function IncludesSection() {
  const features = [{
    icon: Calendar,
    title: 'Plan de 14 días',
    desc: 'Solo 20-25 minutos diarios. Un paso a paso claro para cada día.'
  }, {
    icon: Activity,
    title: 'Rutinas Seguras',
    desc: 'Ejercicios usando solo una silla, una pared y una banda elástica.'
  }, {
    icon: Shield,
    title: 'Semáforo del Dolor',
    desc: "Aprende a distinguir 'molestia buena' de 'señal de alto' para no lastimarte."
  }, {
    icon: Clock,
    title: 'Protocolo de Alivio',
    desc: 'Qué hacer exactamente si tienes un día sensible (24-48h de recuperación).'
  }, {
    icon: BookOpen,
    title: 'Plan de Mantención',
    desc: 'Rutina de 3 veces por semana para conservar lo ganado para siempre.'
  }];
  return <Section background="teal" className="text-white" data-id="element-50">
      <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-51">
        <div data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif" data-id="element-53">
            Todo lo que necesitas para recuperar el control
          </h2>
          <p className="text-[#E8F2F1] text-lg mb-8 leading-relaxed" data-id="element-54">
            Este no es otro PDF con ejercicios sueltos. Es un sistema completo
            diseñado específicamente para la rodilla de una mujer mayor de 65
            años.
          </p>

          <div className="space-y-6" data-id="element-55">
            {features.map((feature, idx) => <div key={idx} className="flex items-start" data-id="element-56">
                <div className="bg-[#144A46] p-3 rounded-lg mr-4 mt-1" data-id="element-57">
                  <feature.icon className="w-6 h-6 text-[#C96B4B]" data-id="element-58" />
                </div>
                <div data-id="element-59">
                  <h3 className="font-bold text-lg text-white" data-id="element-60">
                    {feature.title}
                  </h3>
                  <p className="text-[#E8F2F1] text-sm md:text-base" data-id="element-61">
                    {feature.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>

        <div className="relative hidden lg:block" data-id="element-62">
          <div className="absolute inset-0 bg-[#C96B4B] rounded-full opacity-20 blur-3xl" data-id="element-63"></div>
          <img src="https://cdn.magicpatterns.com/uploads/hG53EhvcYRZmMHqcyFHyCx/gemini-generated-image-1769840339697.png" alt="Preview del contenido" className="relative z-10 rounded-xl shadow-2xl border-4 border-[#144A46] rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-64" />
        </div>
      </div>
    </Section>;
}